export default __webpack_public_path__ + "static/media/novaposta.deba50f5.ico";